// Server configuration constants
export const SERVER_HOST = process.env.REACT_APP_SERVER_HOST || 'ai-server.aoknos.com';
export const SERVER_PROTOCOL = process.env.REACT_APP_SERVER_PROTOCOL || 'https';
export const SERVER_PORT = process.env.REACT_APP_SERVER_PORT || '8000';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || `${SERVER_PROTOCOL}://${SERVER_HOST}:${SERVER_PORT}/api/v1`;

// Google OAuth configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Authentication endpoints
export const AUTH_ENDPOINTS = {
  GOOGLE_LOGIN: `${API_BASE_URL}/auth/google`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  VERIFY_TOKEN: `${API_BASE_URL}/auth/verify`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh`
};